const logo = require("../images/logo.png");
const errorPage = require("../images/svg/404.svg");
const noResult = require("../images/noresult.jpg");

export { logo, errorPage, noResult };
